import GlyphIcon from "./GlyphIcon.mjs";

/**
 * Glyphicon 425-crown
 * @see {GlyphIcon}
 */
const CrownIcon = class extends GlyphIcon {
	constructor(props) {
		super(props);
		this.state.d="M8,25H24v2a1,1,0,0,1-1,1H9a1,1,0,0,1-1-1ZM28,9H26a1,1,0,0,0-1,1v1.65521a1.00008,1.00008,0,0,1-.41449.81067l-3.8501,2.7807L17.56134,7.70819a1.07138,1.07138,0,0,1,.22125-1.09875A.95448.95448,0,0,0,18,6V4a1,1,0,0,0-1-1H15a1,1,0,0,0-1,1V6a.95448.95448,0,0,0,.21741.60944,1.07138,1.07138,0,0,1,.22125,1.09875l-3.17407,7.53839-3.8501-2.7807A1.00008,1.00008,0,0,1,7,11.65521V10A1,1,0,0,0,6,9H4a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1h.18451a1.00007,1.00007,0,0,1,.95581.70587L8,23H24l2.85968-9.29413A1.00007,1.00007,0,0,1,27.81549,13H28a1,1,0,0,0,1-1V10A1,1,0,0,0,28,9Z";
	}
}

export default CrownIcon;
